import { useTranslation } from 'react-i18next';

import { DailyChart } from '../components/DailyChart';
import { TotalsSummary } from '../components/TotalsSummary';
import { useReports } from '../hooks/useReports';
import styles from './ReportsScreen.module.css';

// PARA-105, AC-4: раздел отчётов — период по умолчанию последние 7 дней.
// PARA-122 (D12, AC-10): заголовок/период по типо-шкале + --screen-pad-x.
export function ReportsScreen(): JSX.Element {
  const { t } = useTranslation('reports');
  const { data } = useReports();
  const daily = data?.daily ?? [];

  return (
    <div className={styles.screen}>
      <header className={styles.header}>
        <h1 className={styles.title}>{t('title')}</h1>
        <p className={styles.period}>{t('period')}</p>
      </header>
      <DailyChart daily={daily} />
      <TotalsSummary daily={daily} />
    </div>
  );
}
